export default function (Site, $) {
  Site.widget('date', {
    _create () {
      this.DOM = this.getDOM()

      this.updateValues()
    },
    async updateValues () {
      const now = new Date()

      /* if (this.lastDay !== undefined && now.getDate() !== this.lastDay) {
        const widget = Site.findWidget('homepage-anim')
        $('body').addClass('show-blue')
        await widget._transitionIn()
        $('body').removeClass('show-blue')
      } */

      this.lastDay = now.getDate()
      this.DOM.day.text(`${day(now)},`)
      this.DOM.month.text(`${month(now)} ${now.getDate()},`)
      this.DOM.year.text(now.getFullYear())
    },
    getDOM () {
      return {
        day: this.element.find('.day'),
        month: this.element.find('.month'),
        year: this.element.find('.year')
      }
    }
  })
}

function day (date) {
  return [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ][date.getDay()]
}

function month (date) {
  return [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ][date.getMonth()]
}
